import { ImageComparisonSlider } from "./ImageComparisonSlider";
import comparisonTshirt from "@/assets/e36-shirt.webp";
import comparisonHoodie from "@/assets/lbwk-hoodie-transparent.webp";

export const AnnouncementSection = () => {
  return (
    <section className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center">
          {/* Left: Text */}
          <div className="text-center md:text-left">
            <h2 className="section-title text-gradient-red mb-6 animate-slide-up font-thin">
              Who is Outlaws?
            </h2>
            <p className="text-muted-foreground text-lg leading-relaxed animate-slide-up delay-200">
              ØUTLAWS is not a brand. It is a movement. We exist for the rule-breakers, the
              risk-takers, and the ones who refuse to blend in. Built from raw passion, loud
              engines, and unapologetic ambition, ØUTLAWS stands against the ordinary. We do
              not follow trends. We set them.
            </p>
          </div>

          {/* Right: Comparison Slider */}
          <div className="w-full max-w-lg mx-auto md:mx-0 animate-fade-in delay-300">
            <ImageComparisonSlider
              leftImage={comparisonTshirt}
              rightImage={comparisonHoodie}
              leftAlt="Outlaws T-shirt"
              rightAlt="Outlaws Hoodie"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
